import { ApiClient } from "../ApiClient";
import config from "../utils/config";
class OrdersApiClient {
    constructor() {
        this.http = new ApiClient(config.gatewayApiUrl);
    }
    getOrders(limit, page) {
        return this.http.get(`/v2/orders?limit=${limit}&page=${page}`);
    }
}
const orderApiClient = new OrdersApiClient();
export default orderApiClient;
